<template>
  <div class="stock_table_box">

    <div class="lk-popup add_form" v-if="button === 'edit'" style="position: fixed;left: 0;right: 0;top: 12%;z-index: 999;height: auto;">
      <div class="title">
        <h1 style="display: inline-block;" v-if="!currentStock.id">Добавить акцию</h1>
        <h1 style="display: inline-block;" v-else>Изменение акции</h1>
        <button class="cross" @click="button = null, currentStock = {}" style="background: none;border: 0; float: right"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/referals/cross.svg" alt=""></button>
      </div>
      <div class="content_box">
        <div class="tags_box">
          <span :class="type==='standart'?'tag active':'tag'" @click="type='standart'">СТАНДАРТНАЯ АКЦИЯ</span>
          <!--span :class="type==='price'?'tag active':'tag'" @click="type='price'">БЛЮДА ПО ДРУГОЙ ЦЕНЕ</span>
          <span :class="type==='free'?'tag active':'tag'" @click="type='free'">БЛЮДО В ПОДАРОК</span>
          <span :class="type==='present'?'tag active':'tag'" @click="type='present'">ПОДАРОК ПРИ ЗАКАЗЕ НА СУММУ</span>
          <span :class="type==='hour'?'tag active':'tag'" @click="type='hour'">СЧАСТЛИВЫЕ ЧАСЫ</span-->
        </div>
        <div class="dish_form" v-if="type === 'standart'">

          <div class="bottom_part">

            <div class="info_row file">
              <span class="input_description">Фото</span>
              <input class="file_input" id="file_avatar" name="file_avatar" type="file" ref="file" v-on:change="handleFileUpload()">
              <label for="file_avatar" v-if="!currentStock.id"></label>
              <label for="file_avatar" v-else :style="{backgroundSize: '100% auto', backgroundRepeat: 'no-repeat', backgroundImage: 'url(' + currentStock.photo + ')'}"></label>
            </div>

            <div class="info_row">
              <span class="input_description">Продукт</span>
              <select class="select_product select_info full" v-model="currentStock.product_id">
                <option v-if="currentStock.product_id" :value="currentStock.product_ids">{{currentStock.product_name}}</option>
              </select>
            </div>

            <div class="info_row">
              <span class="input_description">Текст акции<br><small>краткий</small></span>
              <textarea class="textarea" placeholder="Введите текст" v-model="currentStock.short_text"></textarea>
            </div>

            <div class="info_row">
              <span class="input_description">Текст акции<br><small>полный</small></span>
              <textarea class="textarea full" placeholder="Введите текст" v-model="currentStock.text"></textarea>
            </div>

            <div class="info_row">
              <span class="input_description">Описание</span>
              <textarea class="textarea full" placeholder="Введите текст" v-model="currentStock.description"></textarea>
            </div>

            <div class="info_row" style="display: none">
              <span class="input_description">Тип работы</span>
              <div class="checkbox_wrap">
                <input type="radio" name="sms" id="sms1">
                <label class="radio_label" for="sms1"></label>
                <span>По периоду работы</span>
              </div>
              <div class="checkbox_wrap">
                <input type="radio" name="sms" id="sms2">
                <label class="radio_label" for="sms2"></label>
                <span>Бессрочная</span>
              </div>
            </div>

            <div class="calendar_wrap">
              <div class="info_row">
                <span class="input_description">Дата начала</span>
                <input class="calendar_input" type="date" placeholder="__-__-____" v-model="currentStock.from">
              </div>

              <div class="info_row">
                <span class="input_description">Дата завершения</span>
                <input class="calendar_input" type="date" placeholder="__-__-____" v-model="currentStock.to">
              </div>
            </div>

            <div class="info_row padding">
              <span class="input_description">Скидка, %</span>
              <div class="extra_info">
                <input type="number" min="0" value="0" class="extra" v-model="currentStock.discount">
                <select class="select_info extra" name="amount" style="display: none">
                  <option value="1">Процент</option>
                  <option value="2">Такой</option>
                </select>
              </div>
            </div>
          </div>

          <button class="menu_item_btn" @click="saveData">Сохранить</button>

        </div>
        <div class="dish_form" v-if="type === 'price'">

          <div class="bottom_part">

            <div class="info_row file">
              <span class="input_description">Фото</span>
              <input class="file_input" id="file_avatar2" name="file_avatar" type="file">
              <label for="file_avatar2"></label>
            </div>

            <div class="info_row">
              <span class="input_description">Текст акции<br><small>краткий</small></span>
              <textarea class="textarea" placeholder="Введите текст"></textarea>
            </div>

            <div class="info_row">
              <span class="input_description">Текст акции<br><small>полный</small></span>
              <textarea class="textarea full" placeholder="Введите текст"></textarea>
            </div>

            <div class="info_row">
              <span class="input_description">Описание</span>
              <textarea class="textarea full" placeholder="Введите текст"></textarea>
            </div>

            <div class="info_row">
              <span class="input_description">Количество блюд</span>
              <select class="select_info small" name="amount">
                <option value="1">0</option>
                <option value="2">1</option>
              </select>
            </div>

            <div class="info_row">
              <span class="input_description">По цене блюд</span>
              <select class="select_info small" name="amount">
                <option value="1">0</option>
                <option value="2">1</option>
              </select>
            </div>

            <div class="info_row">
              <span class="input_description">Тип работы</span>
              <div class="checkbox_wrap">
                <input type="radio" name="sms" id="sms12">
                <label class="radio_label" for="sms12"></label>
                <span>По периоду работы</span>
              </div>
              <div class="checkbox_wrap">
                <input type="radio" name="sms" id="sms22">
                <label class="radio_label" for="sms22"></label>
                <span>Бессрочная</span>
              </div>
            </div>

            <div class="calendar_wrap">
              <div class="info_row">
                <span class="input_description">Дата начала</span>
                <input class="calendar_input" type="text" placeholder="__-__-____">
              </div>

              <div class="info_row">
                <span class="input_description">Дата завершения</span>
                <input class="calendar_input" type="text" placeholder="__-__-____">
              </div>
            </div>
          </div>

          <button class="menu_item_btn">Сохранить</button>

        </div>
        <div class="dish_form" v-if="type === 'free'">

          <div class="bottom_part">

            <div class="info_row file">
              <span class="input_description">Фото</span>
              <input class="file_input" id="file_avatar3" name="file_avatar" type="file">
              <label for="file_avatar3"></label>
            </div>

            <div class="info_row">
              <span class="input_description">Продукт</span>
              <input class="max" type="text" placeholder="Введите текст">
            </div>

            <div class="info_row">
              <span class="input_description">Текст акции<br><small>краткий</small></span>
              <textarea class="textarea" placeholder="Введите текст"></textarea>
            </div>

            <div class="info_row">
              <span class="input_description">Текст акции<br><small>полный</small></span>
              <textarea class="textarea full" placeholder="Введите текст"></textarea>
            </div>

            <div class="info_row">
              <span class="input_description">Описание</span>
              <textarea class="textarea full" placeholder="Введите текст"></textarea>
            </div>

            <div class="info_row">
              <span class="input_description">Тип работы</span>
              <div class="checkbox_wrap">
                <input type="radio" name="sms" id="sms13">
                <label class="radio_label" for="sms13"></label>
                <span>По периоду работы</span>
              </div>
              <div class="checkbox_wrap">
                <input type="radio" name="sms" id="sms23">
                <label class="radio_label" for="sms23"></label>
                <span>Бессрочная</span>
              </div>
            </div>
            <div class="calendar_wrap">
              <div class="info_row">
                <span class="input_description">Дата начала</span>
                <input class="calendar_input" type="text" placeholder="__-__-____">
              </div>

              <div class="info_row">
                <span class="input_description">Дата завершения</span>
                <input class="calendar_input" type="text" placeholder="__-__-____">
              </div>
            </div>
          </div>

          <button class="menu_item_btn">Сохранить</button>

        </div>
        <div class="dish_form" v-if="type === 'present'">

          <div class="bottom_part">

            <div class="info_row file">
              <span class="input_description">Фото</span>
              <input class="file_input" id="file_avatar4" name="file_avatar" type="file">
              <label for="file_avatar4"></label>
            </div>

            <div class="info_row">
              <span class="input_description">Продукт</span>
              <input class="max" type="text" placeholder="Введите текст">
            </div>

            <div class="info_row">
              <span class="input_description">Текст акции<br><small>краткий</small></span>
              <textarea class="textarea" placeholder="Введите текст"></textarea>
            </div>

            <div class="info_row">
              <span class="input_description">Текст акции<br><small>полный</small></span>
              <textarea class="textarea full" placeholder="Введите текст"></textarea>
            </div>

            <div class="info_row">
              <span class="input_description">Описание</span>
              <textarea class="textarea full" placeholder="Введите текст"></textarea>
            </div>

            <div class="info_row">
              <span class="input_description">Тип работы</span>
              <div class="checkbox_wrap">
                <input type="radio" name="sms" id="sms14">
                <label class="radio_label" for="sms14"></label>
                <span>По периоду работы</span>
              </div>
              <div class="checkbox_wrap">
                <input type="radio" name="sms" id="sms24">
                <label class="radio_label" for="sms24"></label>
                <span>Бессрочная</span>
              </div>
            </div>
            <div class="calendar_wrap">
              <div class="info_row">
                <span class="input_description">Дата начала</span>
                <input class="calendar_input" type="text" placeholder="__-__-____">
              </div>

              <div class="info_row">
                <span class="input_description">Дата завершения</span>
                <input class="calendar_input" type="text" placeholder="__-__-____">
              </div>
            </div>

            <div class="info_row padding">
              <span class="input_description">Сумма заказа</span>
              <input class="number" placeholder="Введите число">
            </div>
          </div>

          <button class="menu_item_btn">Сохранить</button>

        </div>
        <div class="dish_form" v-if="type === 'hour'">

          <div class="top_part">

            <div class="info_row file">
              <span class="input_description">Фото</span>
              <input class="file_input" id="file_avatar5" name="file_avatar" type="file">
              <label for="file_avatar5"></label>
            </div>

            <div class="info_row">
              <span class="input_description">Текст акции<br><small>краткий</small></span>
              <textarea class="textarea" placeholder="Введите текст"></textarea>
            </div>

            <div class="info_row">
              <span class="input_description">Текст акции<br><small>полный</small></span>
              <textarea class="textarea full" placeholder="Введите текст"></textarea>
            </div>

            <div class="info_row">
              <span class="input_description">Описание</span>
              <textarea class="textarea full" placeholder="Введите текст"></textarea>
            </div>
          </div>

          <div class="bottom_part">

            <div class="info_row">
              <span class="input_description">Категории</span>
              <select class="select_info" name="amount">
                <option value="1">Выберите значение</option>
                <option value="2">2</option>
              </select>
            </div>

            <div class="info_row">
              <span class="input_description">Время работы</span>
              <div class="work_time_box">
                <select class="select_info" name="amount">
                  <option value="1">Выберите значение</option>
                  <option value="2">2</option>
                </select>
                <div class="time">
                  <select class="select_info" name="amount">
                    <option value="1"></option>
                    <option value="2"></option>
                  </select>
                  <select class="select_info" name="amount">
                    <option value="1"></option>
                    <option value="2"></option>
                  </select>
                </div>
              </div>

            </div>

            <div class="info_row">
              <span class="input_description">Тип работы</span>
              <div class="checkbox_wrap">
                <input type="radio" name="sms" id="sms15">
                <label class="radio_label" for="sms15"></label>
                <span>По периоду работы</span>
              </div>
              <div class="checkbox_wrap">
                <input type="radio" name="sms" id="sms25">
                <label class="radio_label" for="sms25"></label>
                <span>Бессрочная</span>
              </div>
            </div>

            <div class="calendar_wrap">
              <div class="info_row">
                <span class="input_description">Дата начала</span>
                <input class="calendar_input" type="text" placeholder="__-__-____">
              </div>

              <div class="info_row">
                <span class="input_description">Дата завершения</span>
                <input class="calendar_input" type="text" placeholder="__-__-____">
              </div>
            </div>

            <div class="info_row padding">
              <span class="input_description">Сумма заказа</span>
              <input class="number" placeholder="Введите число">
            </div>
          </div>

          <button class="menu_item_btn">Сохранить</button>

        </div>

      </div>
    </div>
    <div class="toolbar">
      <button @click="button = 'edit'">Добавить</button>
    </div>
    <table class="stock_table" id="stock_table">
      <thead>
        <tr class="row">
          <th>Продукт</th>
          <th>Описание</th>
          <th>Начало</th>
          <th>Завершение</th>
          <th>Скидка</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr class="row" v-for="(stock, index) in stocks" :key="index">
          <td class="td">{{stock.text}}</td>
          <td class="td">{{stock.description}}</td>
          <td class="td">{{stock.from}}</td>
          <td class="td">{{stock.to}}</td>
          <td class="td">{{stock.discount}}%</td>
          <td class="td">
            <button class="button edit" @click="(currentStock = stock, button = 'edit')">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lk/edit.svg" alt="">
            </button>
          </td>
          <td class="td">
            <button class="button cancel" @click="deleteStock(stock)">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lk/cancel.svg" alt="">
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
import 'datatables'
import 'datatables/media/css/jquery.dataTables.css'
export default {
  name: 'stocks',
  props: ['auth', 'id', 'mapinit', 'user'],
  data () {
    return {
      button: null,
      currentStock: {},
      type: 'standart',
      table: null,
      file: null,
      restaurant: {},
      stocks: []
    }
  },
  created () {
    if (this.auth.uid) this.loadRest()
    else {
      setTimeout(() => {
        if (this.auth.uid) this.loadRest()
      }, 100)
    }
  },
  methods: {
    deleteStock (stock) {
      if (confirm('Вы действительно хотите удалить эту акцию?')) {
        var formData = new FormData()
        formData.append('id', this.id)
        formData.append('uid', this.$root.auth.uid)
        formData.append('stock_id', stock.id)
        axios.post('https://lk.when-hungry.com/mobile/delete-stock',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(() => {
          this.table.destroy()
          this.stocks.splice(this.stocks.indexOf(stock), 1)
          setTimeout(() => {
            alert('позиция меню удалена')
          }, 1)
        })
      }
    },
    handleFileUpload () {
      var reader = new FileReader()
      reader.onload = (e) => {
        $('label[for="file_avatar"]').css('background-image', `url(${e.target.result})`)
        this.file = e.target.result
      }
      reader.readAsDataURL(this.$refs.file.files[0])
    },
    loadRest () {
      axios.get('https://lk.when-hungry.com/mobile/get-stocks?uid=' + this.auth.uid + '&id=' + this.id).then(response => {
        this.stocks = response.data.stocks
        this.restaurant = response.data.restaurant
      })
    },

    saveData () {
      this.currentStock.restaurant_id = this.restaurant.id
      this.currentStock.city_id = this.restaurant.city_id
      var formData = new FormData()
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('stock', JSON.stringify(this.currentStock))
      if (this.file !== null) formData.append('photos', this.file)
      axios.post('https://lk.when-hungry.com/mobile/save-stock',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        if (response.data.status === 'error') {
          alert(response.data.text)
        } else {
          this.table.destroy()
          this.loadRest()
          setTimeout(() => {
            alert('Изменения сохранены')
          }, 1)
          this.currentStock = {}
          this.button = null
        }
      })
    }
  },
  watch: {
    'button' (val) {
      let self = this
      if (val) {
        setTimeout(() => {
          $('.select_product').select2({
            width: '100%',
            ajax: {
              url: 'https://lk.when-hungry.com/mobile/search-product',
              data: (params) => {
                params.id = this.restaurant.id
                params.q = params.term
                return params
              },
              dataType: 'json',
              processResults: function (data) {
                return {
                  results: $.map(data, function (key, item) {
                    return {
                      text: key,
                      id: item
                    }
                  })
                }
              }
            }
          }).on('select2:select', function () {
            self.currentStock.product_id = $(this).val()
          })
        }, 300)
      }
    },
    id (val, oldVal) {
      if (val !== oldVal) {
        this.loadRest()
      }
    },
    stocks () {
      setTimeout(() => {
        this.table = $('#stock_table').DataTable({
          'language': {
            'decimal': '',
            'emptyTable': 'No data available in table',
            'info': 'С _START_ до _END_ из _TOTAL_ записей',
            'infoEmpty': 'С 0 до 0 из 0 записей',
            'infoFiltered': '(filtered from _MAX_ total entries)',
            'infoPostFix': '',
            'thousands': ',',
            'lengthMenu': 'Выводить по _MENU_',
            'loadingRecords': 'Loading...',
            'processing': 'Processing...',
            'search': 'Искать:',
            'zeroRecords': 'No matching records found',
            'paginate': {
              'first': 'First',
              'last': 'Last',
              'next': 'След',
              'previous': 'Пред'
            },
            'aria': {
              'sortAscending': ': activate to sort column ascending',
              'sortDescending': ': activate to sort column descending'
            }
          }
        })
      }, 300)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/lk/user/restaurant/stocks.vue